{
  "objectMode": false,
  "decodeStrings": true,
  "defaultEncoding": "utf8"
}
